import { render, staticRenderFns } from "./user-detail-dialog.vue?vue&type=template&id=2ee8ab82&scoped=true"
import script from "./user-detail-dialog.vue?vue&type=script&lang=ts"
export * from "./user-detail-dialog.vue?vue&type=script&lang=ts"
import style0 from "./user-detail-dialog.vue?vue&type=style&index=0&id=2ee8ab82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8ab82",
  null
  
)

export default component.exports